import { getImpersonatedCentroId, getWithDedupe } from './client'

import type { MenuResponse } from '@/types/gia'

const menuApi = {
  async getMenu(centroId?: number | null): Promise<MenuResponse> {
    const resolvedCentro = centroId ?? getImpersonatedCentroId()

    return getWithDedupe<MenuResponse>('/menu/', {
      params: resolvedCentro ? { centro: resolvedCentro } : undefined
    })
  }
}

export default menuApi
